export const city_risks_dictionary = {
  1: ['earthquakes', 'landslides', 'tech_hazards'],
  2: ['earthquakes', 'landslides', 'tech_hazards', 'ind_hazards'],
  3: ['earthquakes', 'tech_hazards', 'ind_hazards'],
  4: ['earthquakes', 'landslides', 'strong_winds', 'tech_hazards'],
  5: ['shoreline_erosion', 'wildfires', 'tech_hazards'],
};
